var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTimeSolid(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 17,
    height: 18,
    viewBox: "0 0 17 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8.4978 17.7637C3.78296 17.7637 -0.00219727 13.9785 -0.00219727 9.26367C-0.00219727 4.58203 3.78296 0.763672 8.4978 0.763672C13.1794 0.763672 16.9978 4.58203 16.9978 9.26367C16.9978 13.9785 13.1794 17.7637 8.4978 17.7637ZM7.70093 9.26367C7.70093 9.5293 7.83374 9.79492 8.03296 9.92773L11.2205 12.0527C11.5857 12.3184 12.0837 12.2188 12.3162 11.8535C12.5818 11.4883 12.4822 10.9902 12.1169 10.7246L9.29468 8.86523V4.74805C9.29468 4.31641 8.92944 3.95117 8.4646 3.95117C8.03296 3.95117 7.66772 4.31641 7.66772 4.74805L7.70093 9.26367Z",
    fill: "black"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTimeSolid);
export default __webpack_public_path__ + "static/media/time-solid.96709293be0882da413ab8d7919cd4ed.svg";
export { ForwardRef as ReactComponent };